import {
    Component,
    OnInit,
    Inject,
    ChangeDetectorRef,
    AfterContentChecked,
    LOCALE_ID,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { Grn } from "../../../_models/table-models";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";

import { DataExportService } from "src/app/_services/dataExportService";
import { formatDate } from "@angular/common";

@Component({
    selector: "app-proof-of-delivery",
    templateUrl: "./proof-of-delivery.component.html",
    styleUrls: ["./proof-of-delivery.component.scss"],
})
export class ProofOfDeliveryComponent implements OnInit {
    searchTerm: string = "";
    pods: Grn[] = [];
    selectedItems = [];
    responseData: any;
    isError: any;
    isEmpty = false;
    loading = true;
    all = false;
    isSelected = false;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    proof: any;
    poNumber: any;
    comparable: any;
    allSubmited = false;
    filterBy: any;
    sessionExpired = false;
    errorMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    selectedOption = false;
    tableData: any;
    impersonate;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private posService: PosService,
        private cdref: ChangeDetectorRef,
        private authService: AuthService,
        private exportService: DataExportService,
        @Inject(LOCALE_ID) public locale: string
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    ngOnInit(): void {
        this.poNumber = this.route.snapshot.params["poNo"];
        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }

        const userData = {
            poNumber: this.poNumber,
            action: "list",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.posService.fecthPod(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;

                if (this.responseData.status === "successful") {
                    this.pods = this.responseData.pods.map((r: any) => ({
                        checked: false,
                        ...r,
                    }));
                    this.collectionSize = this.responseData.pods.length;
                    this.refreshPo();

                    let comparable = [];
                    this.pods.forEach((p: any) => {
                        if (
                            p.status === "Invoiced" ||
                            (p.status === "Not Invoiced" &&
                                p.grn_quality_inspection_status === "FALSE")
                        ) {
                            comparable.push(p);
                        }
                    });

                    if (comparable.length === this.pods.length) {
                        this.allSubmited = true;
                    }
                } else {
                    this.loading = false;
                    this.isEmpty = true;
                }
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
            }
        );
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    // ngAfterContentChecked() {
    //     this.cdref.detectChanges();
    // }

    checkAll(ev: any) {
        this.proof.forEach((x: any) => {

            //OLD CODE
            // x.checked = ev.target.checked;
            // this.onCheckboxChange(x.id - 1);
            
            // Only check items that meet the condition: status === 'Not Invoiced' AND grn_quality_inspection_status === 'TRUE'
            if (x.status === 'Not Invoiced' && x.grn_quality_inspection_status === 'TRUE') {
                x.checked = ev.target.checked;
                this.onCheckboxChange(x.id - 1); // Manually call the handler for each checkbox
            } else {
                // Uncheck items that don't meet the condition
                x.checked = false;
                this.onCheckboxChange(x.id - 1);
            }
        });
        console.log(this.proof);
    }

    isAllCheck() {
        this.onSelectChanges();
        return this.proof.every((p: any) => p.checked);
    }

    onSelectChanges() {
        const itemsChecked = this.proof.filter((p: any) => p.checked);

        // itemsChecked.forEach((item) => {
        //     this.selectedItems.push(item);
        //     console.log(this.selectedItems);
        // });
    }

    onCheckboxChange(index: number) {
        const isChecked = this.proof[index].checked;
        if (isChecked) {
            // Check if the item is already in the selectedItems array
            const exists = this.selectedItems.some(
                (item) =>
                    item.id === this.proof[index].id &&
                    item.po_item_line === this.proof[index].po_item_line
            );

            // Only add the item if it's not already in the array
            if (!exists) {
                this.selectedItems.push(this.proof[index]);
            }
        } else {
            const selectedIndex = this.selectedItems.findIndex(
                (item) => item.id === this.proof[index].id
            );
            if (selectedIndex !== -1) {
                this.selectedItems.splice(selectedIndex, 1);
            }
        }

        this.isSelected = this.selectedItems.length !== 0;
    }

    sendPod(pod = null) {
        if (pod !== null) {
            console.log(pod + " this is the null value");
        } else {
            const selectedPods: any = [];
            // this.proof.forEach((p: any) => {
            //     if (p.checked === true) {
            //         selectedPods.push(p);
            //     }
            //     console.log(selectedPods);

            // });
            if (this.selectedItems.length !== 0) {
                //console.log(this.selectedItems);
                localStorage.setItem(
                    "pods",
                    JSON.stringify(this.selectedItems)
                );
                this.router.navigate(["/submit-invoice", this.poNumber]);
            }
        }
    }

    refreshPo() {
        let sortedPods = this.pods.sort((a, b) =>
            a.grn_no > b.grn_no ? 1 : -1
        );
        this.proof = sortedPods
            .map((po: any, i: any) => ({
                id: i + 1,
                ...po,
                checked: this.selectedItems.some(
                    (selected: any) => selected.id === i + 1
                ),
            }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
    }

    onFilter(option: any) {
        this.filterBy = option.target.value;
        this.selectedOption = true;
    }

    onSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;
        console.log(this.searchTerm);

        if (this.searchTerm !== "") {
            if (this.filterBy === "grn_no") {
                this.proof = this.pods.filter((data) =>
                    (data.grn_no as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "invoice_number") {
                this.proof = this.pods.filter((data) =>
                    data.invoice_number
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "po_item_line") {
                this.proof = this.pods.filter((data) =>
                    data.po_item_line
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "item_code") {
                this.proof = this.pods.filter((data) =>
                    data.item_code
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else {
                this.proof = this.pods.filter((data) =>
                    (data.status as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            }
        } else {
            this.proof = this.pods;
        }
    }

    generalSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            this.proof = this.pods.filter(
                (data) =>
                    (data.grn_no as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.invoice_number
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.grn_year
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.po_item_line
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.grn_quantity
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    (data.status as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    (data.grn_delivery_date as string)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
            );
        } else {
            this.proof = this.pods;
        }
    }

    exportToExcel() {
        const date = new Date();

        const fileName =
            (this.displayName = localStorage.getItem("vendorCode")) +
            "_GRN_Table_" +
            formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

        if (this.selectedOption === false) {
            this.tableData = this.pods;
        } else {
            this.tableData = this.proof;
        }

        const cols = [
            {
                name: "GRN No",
                colKey: "grn_no",
            },
            {
                name: "GRN Invoice No",
                colKey: "invoice_number",
            },
            {
                name: "Year",
                colKey: "grn_year",
            },
            {
                name: "Item Code",
                colKey: "item_code",
            },
            {
                name: "Line Item",
                colKey: "po_item_line",
            },
            {
                name: "GRN Quantity",
                colKey: "grn_quantity",
            },
            {
                name: "Delivery Date",
                colKey: "grn_delivery_date",
            },
            {
                name: "Invoicing Status",
                colKey: "status",
            },
        ];

        this.exportService.exportToExcel(this.tableData, cols, fileName);
    }
}
